import { useState, useEffect, createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";
import EnquiryModal from "@/components/site/EnquiryModal";
import AmbientMusic from "@/components/site/AmbientMusic";
import { track } from "@/lib/analytics";

// First-party pageview + live-presence tracking (public pages only)
function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => { track("pageview"); }, [pathname]);
  useEffect(() => {
    const t = setInterval(() => track("ping"), 60000);
    return () => clearInterval(t);
  }, []);
  return null;
}

const EnquiryCtx = createContext({ open: () => {} });
export const useEnquiry = () => useContext(EnquiryCtx);

// Scrolls to #section anchors after navigation (retries while async content loads)
function HashScroll() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) return;
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        clearInterval(t);
      } else if (++tries > 40) clearInterval(t);
    }, 120);
    return () => clearInterval(t);
  }, [hash, pathname]);
  return null;
}

export default function PublicLayout({ children }) {
  const [open, setOpen] = useState(false);
  const [prop, setProp] = useState("");
  const [prefill, setPrefill] = useState(null);

  const trigger = (slug, pre) => { setProp(slug || ""); setPrefill(pre || null); setOpen(true); };

  return (
    <EnquiryCtx.Provider value={{ open: trigger }}>
      <Header onEnquire={() => trigger("")} />
      <HashScroll />
      <AnalyticsTracker />
      <main className="min-h-screen bg-ivory">{children}</main>
      <Footer />
      <StickyCTA onEnquire={() => trigger("")} />
      <AmbientMusic />
      <EnquiryModal open={open} onClose={() => setOpen(false)} defaultProperty={prop} prefill={prefill} />
    </EnquiryCtx.Provider>
  );
}
